import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreatePage = () => {
  const token = useAuthToken();

  const createPage = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/page", credentials, token);
  };

  return createPage;
};

export const useGetPage = () => {
  const token = useAuthToken();

  const getPage = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }
    return apiRequest("get", "/api/page", null, token);
  };

  return getPage;
};

export const useUpdatePage = (slug) => {
  const token = useAuthToken();

  const updatePage = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/page/${slug}`,
      formData,
      token
    );

    return response;
  };

  return updatePage;
};
